export default __webpack_public_path__ + "static/media/error_black_24dp.e566894b.svg";